import { render, staticRenderFns } from "./organizationInfo.vue?vue&type=template&id=27e0f647&scoped=true&"
import script from "./organizationInfo.vue?vue&type=script&lang=js&"
export * from "./organizationInfo.vue?vue&type=script&lang=js&"
import style0 from "./organizationInfo.vue?vue&type=style&index=0&id=27e0f647&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e0f647",
  null
  
)

export default component.exports